/* eslint-disable */
import React, { Component } from 'react';
import { Container } from './styles';
import { IoMdClose } from 'react-icons/io';
import { FiChevronDown, FiMinus, FiPlus } from 'react-icons/fi';
import Papel from '../../../../assets/emojis/papel/papel@3x.png';
import ModalSelect from './modalSelect';
import ModalItem from './modalItem';
import Modal from 'react-modal';
import Collapse from "@kunukn/react-collapse";
import {CgTrash} from 'react-icons/cg';
import {FiGrid, FiList} from 'react-icons/fi';
import {uniqueId} from 'lodash';
import api from '../../../../services/api';
import {MdReorder, MdMoreVert} from 'react-icons/md';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {Switch} from 'antd';
import ModalApagar from './modalApagar';

import { RenderItens } from '../../../../components/Products/Items';

export default class ModalAdicional extends Component {

    constructor(props) {
        super(props);
        this.state = {
            adicionais: null,
            superUser: false,
            carregou: true,
            id: uniqueId(),
            nome: '',
            preco: '',
            nomeClass: 'div-input',
            precoClass: 'div-input',
            counterMin: 0,
            counterMax: 0,
            modalSelect: false,
            modalItem: false,
            windowWidth: window.innerWidth,
            itens: [],
            tipo_exib: 0,
            edicaoItem: {},
            token: props.token,
            ativo: true,
            modalApagar: false,
            item_delete: null,
            editar: false,
            qtdExata: null,
            precoSoma: "Soma dos valores de cada adicional",
            precoValorAjustado: "Valor ajustado na divisão do preço pelo número de escolhas",
            precoPrevalece: "Prevalece o valor mais alto entre as escolhas"
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentDidMount() {
        Modal.setAppElement('body');
        window.addEventListener("resize", this.handleResize);
        if (JSON.stringify(this.props.prevInfos) !== '{}') {
            const prev = this.props.prevInfos;
            console.log(prev);
            this.setState({
                id: prev.id,
                counterMax: prev.maximo,
                counterMin: prev.minimo,
                adicionais: prev.obrigatorio,
                preco: prev.tipo_cobranca,
                nome: prev.descricao,
                itens: prev.adicionals,
                ativo: prev.ativo,
                editavel: true,
                qtdExata: prev.qtd_exata,
            })
        } else {
            this.setState({
                id: this.state.id,
                counterMax: this.state.counterMax,
                counterMin: this.state.counterMin,
                adicionais: this.state.adicionais,
                preco: this.state.preco,
                nome: this.state.nome,
                itens: this.state.itens,
                ativo: this.state.ativo,
                editavel: false,
                qtdExata: this.state.qtdExata
            })
        }
    }

    async componentWillUnmount() {
        this.props.limparPrevGrupo();
        window.removeEventListener("resize", this.handleResize, false)

    }

    handleInputs(event) {

        this.setState({
            nome: event.target.value
        });
        console.log(event.target.value)

        // switch (event.target.name) {
        //     case 'nome':
        //         this.setState({
        //             nome: event.target.value
        //         });
        //         break;
        //     default:
        //         break;
        // }
    }

    handleCounter(element, type) {
        const min = this.state.counterMin;
        const max = this.state.counterMax;
        // if (element === 'min') {
        //     if (this.state.adicionais) {
        //         if (this.state.preco === "Valor ajustado na divisão do preço pelo número de escolhas" || this.state.preco === "Prevalece o valor mais alto entre as escolhas") {
        //             return null;
        //         } else {
        //             if (type === 'add') {
        //                 if (min >= max) {
        //                     return null
        //                 } else {
        //                     this.setState({
        //                         counterMin: min + 1
        //                     })
        //                 }
        //             }
        //             if (type === 'del') {
        //                 if (min === 1) {
        //                     return null
        //                 } else {
        //                     this.setState({
        //                         counterMin: min - 1
        //                     })
        //                 }
        //             }
        //         }
        //     }
        // }
        // if (element === 'max') {
            if (type === 'add') {
                this.setState({ preco: '' });
                this.setState({
                    counterMax: max + 1
                })
            }
            if (type === 'del') {
                if (max === 1 || min >= max) {
                    return null
                } else {
                    this.setState({ preco: '' });
                    this.setState({
                        counterMax: max - 1
                    })
                }
            }
        //}
    }

    toggleAdicionais(tipo) {
        //resetando opções
        this.setState({ preco: '' });
        this.setState({counterMax: 0 })
        this.setState({qtdExata: null })

        this.setState({ adicionais: tipo });

        if(tipo == false){
            this.setState({ qtdExata: false})
        }

        if(tipo === true){
            this.state.counterMin = 1
        } 
    }

    toggleExata(tipo) {
        //resetando opções
        this.setState({ preco: '' });
        this.setState({counterMax: 0 })

        this.setState({ qtdExata: tipo });
        
    }

    togglePreco(tipo) {
        
        if (tipo === 'soma'){
            this.setState({
                preco: this.state.precoSoma
            });
        }

        if (tipo === 'prevalece'){
            this.setState({
                preco: this.state.precoPrevalece
            });
        }

        if (tipo === 'valor ajustado'){
            this.setState({
                preco: this.state.precoValorAjustado
            });
        }
    }

    controllerModalSelect(estado){
        if (this.state.precoClass === 'div-input') {
            this.setState({
                precoClass: 'div-input-focado'
            })
        } else {
            this.setState({
                precoClass: 'div-input'
            })
        }
        this.setState({
            modalSelect: !estado,
        });
      }

      controllerModalItem(estado){
        this.setState({
            modalItem: !estado,
        });
      }

    setCategoria(nome) {
        this.setState({
            preco: nome
        });
        if (nome === "Valor ajustado na divisão do preço pelo número de escolhas") {
            this.setState({
                adicionais: true,
                counterMin: 1
            })
        }
        if (nome === "Prevalece o valor mais alto entre as escolhas") {
            if (this.state.adicionais) {
                this.setState({
                    counterMin: 1
                })
            } else {
                this.setState({
                    counterMin: 0
                })
            }
        }
        this.controllerModalSelect(this.state.modalSelect);
    }

    orderItems(items) {
        const ordered = items.map((item, index) => {
            item.ordem = index + 1;
            return {...item}
        });
        if (this.props.edicao) {
            try {
                api.patch('api/adicionais/ordenar', {
                    produto_id: this.props.produto_id,
                    grupos_adicional_id: this.props.grupo_id,
                    adicionals: ordered
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    console.log(res.data);
                    this.props.success();
                }).catch(e => {
                    console.log(e);
                    this.props.error();
                })
            } catch (e) {
                console.log(e);
            }
        }
    }

    handleOnDrag = (result) => {
        if (!result.destination) return;
        const items = Array.from(this.state.itens);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        this.setState({
            itens: items
        });
        if (this.props.edicao) {
            this.orderItems(items);
        }
    }

    handleAtivo(id, ativo) {
        if (this.props.edicao) {
            try {
                api.put('api/adicionais/atualizar', {
                    ativo,
                    produto_id: this.props.produto_id,
                    adicional_id: id,
                    grupo_adicional_id: this.props.grupo_id
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    console.log(res.data);
                    this.props.success();
                }).catch(e => {
                    console.log(e);
                    this.props.error();
                })
            } catch (e) {
                console.log(e);
            }
        }
        const array = this.state.itens;
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                array[i].ativo = ativo
            }
        };
        this.setState({
            itens: array
        });
    }

    controllerModalApagar(state, item) {
        this.setState({
            modalApagar: !state,
            item_delete: item
        })
    }

    updateItem = (id, data) => {
        this.setState({ itens: this.state.itens.map(item => {
            return id === item.id 
                ? { ...item, ...data }
                : item;
            })
        });
        console.log(this.state.itens[0].id);
    };

    itensPush(id, ativo, imagem, nome, preco, descricao, editavel) {
            let {itens} = this.state;
            if (JSON.stringify(this.state.edicaoItem) !== '{}') {
                for (let i = 0; i < itens.length; i++) {
                    if (itens[i].id === id) {
                        itens.splice(i, 1, {
                            id: id,
                            ativo: ativo,
                            imagem: imagem,
                            nome: nome,
                            descricao,
                            valor: preco,
                            editavel: editavel
                        });
                    }
                }
            } else {
                itens.push(
                    {
                        id: id,
                        ativo: ativo,
                        imagem: imagem,
                        nome: nome,
                        descricao,
                        valor: preco,
                        editavel: editavel
                    }
                );
            
            this.setState({itens});
        }
        
        // if (edicaoItem === true) {
        //         try {
        //             api.put('api/adicionais/atualizar', {
        //                 ativo,
        //                 nome,
        //                 descricao,
        //                 valor: preco,
        //                 imagem,
        //                 produto_id: this.props.produto_id,
        //                 adicional_id: id,
        //                 grupo_adicional_id: this.props.grupo_id
        //             }, {
        //                 headers: {
        //                     Authorization: `Bearer ${this.state.token}`
        //                 }
        //             }).then(res => console.log(res.data));
        //         } catch (e) {
        //             console.log(e.data);
        //         }
        //     } else {
                // try {
                //     api.post('api/adicionais/criar', {
                //         nome,
	            //         descricao,
	            //         valor: preco,
	            //         ativo: true,
	            //         imagem,
	            //         grupos_adicional_id: this.props.grupo_id,
	            //         produto_id: this.props.produto_id
                //     }, {
                //         headers: {
                //             Authorization: `Bearer ${this.state.token}`
                //         }
                //     }).then(async res => {
                //         this.updateItem(id, {
                //             id: res.data.adicional.id,
                //         });
                //         console.log(res.data)
                //     })
                // } catch (e) {
                //     console.log(e.data);
                // }
            // }
        this.controllerModalItem(this.state.modalItem);
    }

    editarItem(item) {
        this.setState({edicaoItem: item});
        this.controllerModalItem(this.state.modalItem);
    }

    criarItem() {
        this.setState({edicaoItem: {}});
        this.controllerModalItem(this.state.modalItem);
    }

    deleteItem(item) {
        let {itens} = this.state;
        for (let i = 0; i < itens.length; i++) {
            if (itens[i].id === item.id) {
                itens.splice(i, 1)
            }
        }
        if (this.props.edicao) {
            if (typeof item.id === 'number') {
                try {
                    api.put('api/adicionais/deletar', {
                        produto_id: this.props.produto_id,
                        adicional_id: item.id,
	                    grupo_adicional_id: this.props.grupo_id
                    }, {
                        headers: {
                            Authorization: `Bearer ${this.state.token}`
                        }
                    }).then(res => {
                        console.log('retorno: ', res.data);
                        this.props.success();
                    }).catch(e => {
                        this.props.error();
                    });
                } catch (e) {
                    console.log(e.data);
                }
            }
        }
        this.controllerModalApagar(this.state.modalApagar, null);
    }

    handleSave() {
        if (!!this.state.nome && !! this.state.preco) {
            this.props.push(this.state.id, this.state.ativo, this.state.nome, this.state.adicionais, this.state.counterMin, this.state.counterMax, this.state.preco, this.state.itens, this.state.editavel, this.state.qtdExata)
        } else {
            if (!this.state.nome) {
                this.setState({nomeClass: 'div-input-error'})
            }
            if (!this.state.preco) {
                this.setState({precoClass: 'div-input-error'})
            }
        }
    }

    scrollNextOption = (tipo) =>{

        if(tipo == 'obrigatorio'){
            setTimeout(() => {
                document.getElementById('qtd').scrollIntoView({behavior: 'smooth'})
            }, 300)
        } else if(tipo == 'qtd'){
            setTimeout(() => {
                document.getElementById('counter').scrollIntoView({behavior: 'smooth'})
            }, 300)
        } else if(tipo == 'counter' && this.state.qtdExata != null){
            setTimeout(() => {
                document.getElementById('preco').scrollIntoView({behavior: 'smooth'})
            }, 300)
        } else if(tipo == 'options'){
            setTimeout(() => {
                document.getElementById('itens').scrollIntoView({behavior: 'smooth'})
            }, 300)
        }

    }

    render() {
        return (
            <Container>
                <Modal
                    isOpen={this.state.modalApagar}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalApagar(this.state.modalApagar, null)}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={100}
                    style={apagarStyle}
                    contentLabel="Modal"
                    >
                        <ModalApagar 
                            item={this.state.item_delete}
                            confirm={(item) => this.deleteItem(item)}
                            closeModal={() => this.controllerModalApagar(this.state.modalApagar, null)}
                        />
                    </Modal>
                <Modal
                    isOpen={this.state.modalSelect}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalSelect(this.state.modalSelect)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                        <ModalSelect
                            // salvar={(id, turno, entrada, saida) => this.salvar(id, turno, entrada, saida)}
                            // id={this.state.id}
                            // turno={this.state.qualTurno}
                            min={this.state.counterMin}
                            max={this.state.counterMax}
                            adicionais={this.state.adicionais}
                            categorias={this.state.categorias}
                            selecionar={(nome) => this.setCategoria(nome)}
                            closeModal={() => this.controllerModalSelect(this.state.modalSelect)}/>
                </Modal>
                <Modal
                    isOpen={this.state.modalItem}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalItem(this.state.modalItem)}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={100}
                    style={adicionalStyle}
                    contentLabel="Modal"
                    >
                        <ModalItem
                            // salvar={(id, turno, entrada, saida) => this.salvar(id, turno, entrada, saida)}
                            // id={this.state.id}
                            // turno={this.state.qualTurno}
                            // categorias={this.state.categorias}
                            // selecionar={(nome) => this.setCategoria(nome)}
                            token={this.state.token}
                            edicao={this.props.edicao}
                            prevInfos={this.state.edicaoItem}
                            push={(id, ativo, imagem, nome, preco, descricao, editavel) => this.itensPush(id, ativo, imagem, nome, preco, descricao, editavel)}
                            closeModal={() => this.controllerModalItem(this.state.modalItem)}/>
                </Modal>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                
                <div className="header">
                    <img alt="" className="emoji" src={Papel} />
                    <h1>Vamos configurar <p>o seu grupo adicional</p></h1>
                </div>

                <div className="info">
                    <h4>Informações básicas</h4>
                    <div className={this.state.nomeClass}>
                            <input
                                value={this.state.nome}
                                onFocus={() => {
                                    this.setState({
                                        nomeClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        nomeClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleInputs(e) : null 
                        : this.handleInputs(e)
                                }
                                name="nome"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Nome do grupo</span>
                            </label>
                    </div>
                    {this.state.nomeClass === 'div-input-error' && 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Campo obrigatório</span>
                    </div>}
                </div>

                {/* PRIMEIRO PASSO */}
                <div className="obrigatorio">
                    <h4>É obrigatório?</h4>

                    <div className="options">
                        <div onClick={
                            () => {this.state.superUser ? 
                            this.state.permission === 2 ? this.toggleAdicionais(false) : null 
                            : this.toggleAdicionais(false)

                            this.scrollNextOption('obrigatorio')
                        }}
                            name="nao"
                            className={this.state.adicionais == false ? 'option-selected' : 'option'}>
                            <span>Não</span>
                        </div>
                        <div onClick={
                            () => {this.state.superUser ? 
                            this.state.permission === 2 ? this.toggleAdicionais(true) : null 
                            : this.toggleAdicionais(true)

                            this.scrollNextOption('obrigatorio')
                        }}
                            name="sim"
                            className={this.state.adicionais ? 'option-selected' : 'option'}>
                            <span>Sim</span>
                        </div>
                    </div>
                </div>

                {/* SEGUNDO PASSO */}
                {this.state.adicionais != null &&
                    <>
                        <div id="qtd" className="maxOuExata">
                            <h4>Como será a escolha das opções?</h4>

                            <div className="options">
                                <div onClick={() => {this.toggleExata(false), this.scrollNextOption('qtd')}}
                                    className={this.state.qtdExata ==false? 'option-selected' : 'option'}
                                >
                                    <span>Até uma quantidade máxima</span>
                                </div>

                                {this.state.adicionais == true &&
                                    <div onClick={() => {this.toggleExata(true), this.scrollNextOption('qtd')}}
                                        className={this.state.qtdExata ? 'option-selected' : 'option'}
                                    >
                                        <span>Uma quantidade exata</span>
                                    </div>
                                }
                            </div>
                        </div>
                        {this.state.qtdExata != null &&
                            <div id="counter" className="min-max">
                                <div className="min">
                                    <h4>Qual será a quantidade {this.state.qtdExata ? 'exata' : this.state.qtdExata == false ? 'maxima' : null}?</h4>

                                    <div className="counter">
                                        <button 
                                            onClick={() => this.handleCounter('max', 'del')}>
                                            <FiMinus color={
                                                this.state.counterMax > 1 && this.state.counterMax > this.state.counterMin ? '#c32027' : '#c0b7b8'
                                            } className="icon" />
                                        </button>
                                        <span>{this.state.counterMax}</span>
                                        <button
                                            onClick={() => {
                                                // this.setState({
                                                // counterMax: this.state.counterMax + 1})
                                                this.handleCounter('max', 'add')
                                                this.scrollNextOption('counter')
                                            }}>
                                            <FiPlus color={
                                                '#c32027'
                                            } className="icon" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                }

                {/* {this.state.adicionais === false ? */}
                {/* <div className="min-max">
                    <div className="min">
                        <h4>Quantidade mínima</h4>
                        <div className="counter">
                            <button 
                                onClick={() => this.handleCounter('min', 'del')}>
                                <FiMinus color={
                                    this.state.counterMin > 1 ? '#c32027' : '#c0b7b8'
                                } className="icon" />
                            </button>
                            <span style={!this.state.adicionais ? {color: "#c0b7b8"} : null}>{this.state.counterMin}</span>
                            <button
                                onClick={() => this.handleCounter('min', 'add')}>
                                <FiPlus color={
                                    this.state.adicionais && this.state.preco !== "Valor ajustado na divisão do preço pelo número de escolhas" && this.state.preco !== "Prevalece o valor mais alto entre as escolhas" && this.state.counterMin < this.state.counterMax ? 
                                    '#c32027' : '#c0b7b8'
                                } className="icon" />
                            </button>
                        </div>
                    </div>
                    <div className="max">
                        <h4>Quantidade máxima</h4>

                        <div className="counter">
                            <button 
                                onClick={() => this.handleCounter('max', 'del')}>
                                <FiMinus color={
                                    this.state.counterMax > 1 && this.state.counterMax > this.state.counterMin ? '#c32027' : '#c0b7b8'
                                } className="icon" />
                            </button>
                            <span>{this.state.counterMax}</span>
                            <button
                                onClick={() => this.handleCounter('max', 'add')}>
                                <FiPlus color={
                                    '#c32027'
                                } className="icon" />
                            </button>
                        </div>
                    </div>
                </div> */}
                {/* : false} */}

                {/* TERCEIRO PASSO */}
                {this.state.qtdExata != null && this.state.counterMax > 0  ?
                
                    <div className="preco">
                        <h4>Como será o preço?</h4>

                        {/* Qtde == 1 */}
                        {this.state.counterMax === 1 &&
                            <div id="preco" className="options">
                                <div 
                                onClick={() => {this.togglePreco('soma'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoSoma) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoSoma}</span>
                                </div>
                            </div>
                        }

                        {/*Qtde > 1 e não obrigatorio */}
                        {this.state.counterMax > 1 && this.state.adicionais == false &&
                            <div id="preco" className="options">
                                <div onClick={() => {this.togglePreco('soma'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoSoma) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoSoma}</span>
                                </div>

                                <div onClick={() => {this.togglePreco('prevalece'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoPrevalece) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoPrevalece}</span>
                                </div>
                            </div>
                        }

                        {/*Qtde > 1, É obrigatorio e escolha até uma qtde MÁXIMA  */}
                        {this.state.counterMax > 1 && this.state.adicionais == true && this.state.qtdExata == false &&
                            <div id="preco" className="options">
                                <div onClick={() => {this.togglePreco('prevalece'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoPrevalece) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoPrevalece}</span>
                                </div>

                                <div onClick={() => {this.togglePreco('valor ajustado'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoValorAjustado) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoValorAjustado}</span>
                                </div>
                            </div>
                        }

                        {/*Qtde > 1, É obrigatorio e escolha até uma qtde EXATA  */}
                        {this.state.counterMax > 1 && this.state.adicionais == true && this.state.qtdExata == true &&
                            <div id="preco" className="options">
                                <div onClick={() => {this.togglePreco('prevalece'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoPrevalece) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoPrevalece}</span>
                                </div>

                                <div onClick={() => {this.togglePreco('soma'), this.scrollNextOption('options')}}
                                    className={this.state.preco.includes(this.state.precoSoma) ? 'option-selected' : 'option'}
                                >
                                    <span>{this.state.precoSoma}</span>
                                </div>
                            </div>
                        }                    
                        {/* <div
                            onClick={() => this.controllerModalSelect(this.state.modalSelect)}
                            className={this.state.precoClass}>
                                <input
                                    value={this.state.preco}
                                    // onFocus={() => {
                                    //     this.setState({
                                    //         categoriaClass: 'div-input-focado'
                                    //     })
                                    // }}
                                    // onBlur={() => {
                                    //     this.setState({
                                    //         categoriaClass: 'div-input'
                                    //     })
                                    // }}
                                    // readOnly
                                    name="preco"
                                    type="text"
                                    // placeholder="Digite o seu usuário"
                                    required 
                                    />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Escolha uma opção</span>
                                </label>
                                <button
                                    className="icon"
                                    onClick={() => this.controllerModalSelect(this.state.modalSelect)}
                                    >
                                    <FiChevronDown color="#1c0506" className="i" />
                                </button>
                        </div>
                        {this.state.precoClass === 'div-input-error' && 
                        <div className="div-invalido">
                            <span
                            className='texto-invalido'
                            >Campo obrigatório</span>
                        </div>} */}
                    </div>
                    :null
                }

                {this.state.preco &&
                    <>
                        <hr/>
                        <div id="itens" className="itens-adicional">
                            <h4 className="title-h4">Itens dentro dos adicionais</h4>
                            {<RenderItens 
                                type={this.state.tipo_exib} 
                                itens={this.state.itens}
                                setExib={(type) => this.setState({
                                    tipo_exib: type
                                })}
                                nome={this.state.nome}
                                controllerModalApagar={(modalApagar, item) => this.controllerModalApagar(modalApagar, item)}
                                modalApagar={this.state.modalApagar}
                                editarItem={(item) => this.editarItem(item)}
                                handleOnDrag={this.handleOnDrag}
                                windowWidth={this.state.windowWidth}
                                handleAtivo={(id, ativo) => this.handleAtivo(id, ativo)}
                                isSuperUser={this.state.superUser}
                                permission={this.state.permission}

                            />}
                            <div className="botao-div">
                                <button
                                    className="salvar-branco" 
                                    onClick={() => this.criarItem()}>
                                        Novo adicional</button>
                            </div>
                        </div>

                        <div className="botao-div" style={{paddingBottom: 64, paddingTop: 24}}>
                            <button
                                className="salvar" 
                                onClick={() => this.handleSave()}>
                                    Salvar alterações</button>
                        </div>
                    </>
                }
            </Container>
        )
    }
}

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '256px'
      }
  };

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };

  const adicionalStyle = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '775px',
        height: '100%',
        maxHeight: '800px'
      }
  };

  const apagarStyle = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '714px',
        height: '100%',
        maxHeight: '432px'
      }
  };